// extracted by mini-css-extract-plugin
module.exports = {"list":"_3peKTZVAkwkfQTmAM89LwL"};